import { CurriculumCountryCodes } from '../constants/curriculum.const'

interface Props {
  countryCode: string
  grade: string
}

export function isParamsCountryCodeValid(countryCode: string): boolean {
  const [gradeLabel, code] = countryCode.split('-')

  return gradeLabel === 'grade' && Object.values(CurriculumCountryCodes).includes(code as CurriculumCountryCodes)
}

export function isGradeValid(grade: string): boolean {
  const gradeNo = Number(grade)
  return Number.isInteger(gradeNo) && gradeNo > 0
}

export function isParamsCountryCodeAndGradeValid({ countryCode, grade }: Props): boolean {
  return isParamsCountryCodeValid(countryCode) && isGradeValid(grade)
}

export function isMappingQuizApplicable({ countryCode, grade }: Props): boolean {
  const gradeNo = Number(grade)
  return (
    gradeNo >= 5 &&
    (countryCode === CurriculumCountryCodes.NORWAY ||
      countryCode === CurriculumCountryCodes.USA ||
      countryCode === CurriculumCountryCodes.FLORIDA ||
      countryCode === CurriculumCountryCodes.UKRAINIAN ||
      countryCode === CurriculumCountryCodes.DEFAULT)
  )
}

export function isMasteryTrackApplicable({ countryCode }: { countryCode: string }): boolean {
  return (
    countryCode === CurriculumCountryCodes.NORWAY ||
    countryCode === CurriculumCountryCodes.USA ||
    countryCode === CurriculumCountryCodes.FLORIDA ||
    countryCode === CurriculumCountryCodes.UKRAINIAN ||
    countryCode === CurriculumCountryCodes.DEFAULT
  )
}

export function isCertificateClaimingApplicable({ countryCode }: { countryCode: string }): boolean {
  return countryCode !== CurriculumCountryCodes.PHILIPPINES
}
